/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SendConsignmentResultMail$Params {
  auctionId: number;
  onlyUnsentParts?: boolean;
  sendExampleForUserId?: number;
  'X-API-Version'?: string;
}

export function sendConsignmentResultMail(http: HttpClient, rootUrl: string, params: SendConsignmentResultMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendConsignmentResultMail.PATH, 'post');
  if (params) {
    rb.path('auctionId', params.auctionId, {});
    rb.query('onlyUnsentParts', params.onlyUnsentParts, {});
    rb.query('sendExampleForUserId', params.sendExampleForUserId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendConsignmentResultMail.PATH = '/api/auctions/{auctionId}/send-consignment-result-mail';
